/* eslint-disable */
import React from "react";
import styled from "styled-components";
import DetailImg1 from "../assets/Detail-1.png";
import DetailImg2 from "../assets/Detail-2.png";
import DetailImg3 from "../assets/Detail-3.png";
import DetailImg4 from "../assets/Detail-4.png";

// Body
function Home() {
  return (
    <Base>
      <FirstBox>
        <DetailImg src={DetailImg1} />
      </FirstBox>
      <SecondBox>
        <DetailImg src={DetailImg2} />
      </SecondBox>
      <ThirdBox>
        <DetailImg src={DetailImg3} />
      </ThirdBox>
      <ForthBox>
        <DetailImg src={DetailImg4} />
        <AbsButton
          onClick={() => {
            {
              window.open("https://forms.gle/oyUHUgcFbZjD9DB39");
            }
          }}
        />
      </ForthBox>
    </Base>
  );
}

export default Home;

// CSS
const Base = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
`;
const FirstBox = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 500px;
  background: linear-gradient(90deg, #33b9dd, #2a4cc7, #ef34a9); ;
`;
const SecondBox = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 500px;
  background-color: #f7f7f7;
`;
const ThirdBox = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 500px;
  background-color: #f7f7f7;
`;
const ForthBox = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 500px;
  background: linear-gradient(90deg, #3b1d9b, #434ff8, #b781f8); ;
`;
const DetailImg = styled.img`
  width: 100%;
  height: 100%;
  max-width: 720px;
  margin: 0;
  padding: 0;
`;

const AbsButton = styled.button`
  position: absolute;
  top: 96.5%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 300px;
  background-color: #00000000;
  border-color: #00000000;
  cursor: pointer;
`;

const Big = styled.text`
  font-size: ${(props) => (props?.active ? 30 : 27)}px;
  color: ${(props) => (props?.active ? "#6BB9FF" : "white")};
  font-weight: 700;
`;
